import axios, { Axios, AxiosResponse } from 'axios';
import { AdminResourceFilterCreateRequest, AdminResourceFilterCreateResponse, AdminResourceFilterListMenuFiltersResponse, AdminResourceFilterListRequest, AdminResourceFilterListResponse, ResourceFilterValue } from '@/venit/services/model/techpubs-cms';

export default class FiltersManagementService {

  public save(request: AdminResourceFilterCreateRequest): Promise<AxiosResponse<AdminResourceFilterCreateResponse>> {
    return axios.post<AdminResourceFilterCreateResponse>('/api/admin/resources/filters/save', request);
  }

  /** Pobranie listy filtrow na potrzeby tabelki */
  public list(request: AdminResourceFilterListRequest): Promise<AxiosResponse<AdminResourceFilterListResponse>> {
    return axios.post<AdminResourceFilterListResponse>('/api/admin/resources/filters/list', request);
  }

  /** Pobranie listy filtrow dla menu */
  public listAllMenuFilters(): Promise<AxiosResponse<AdminResourceFilterListMenuFiltersResponse>> {
    return axios.post<AdminResourceFilterListMenuFiltersResponse>('/api/admin/resources/filters/list-menu-filters');
  }

}
